import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProductConfigurationStateType {
  formData: unknown;
}

export const initialProductConfigurationState: ProductConfigurationStateType = {
  formData: null,
};

const productConfigurationSlice = createSlice({
  name: 'PRODUCT_CONFIGURATION',
  initialState: initialProductConfigurationState,
  reducers: {
    setFormData: (state, action: PayloadAction<unknown>) => {
      state.formData = action.payload;
    },
  },
});

export const { setFormData } = productConfigurationSlice.actions;

export default productConfigurationSlice.reducer;
